import "./DashboardPageHeader.css";

/**
 * Page title block styled like Executive Dashboard (ed-page-header).
 */
export default function DashboardPageHeader({ title, subtitle, eyebrow, actions, extra }) {
  return (
    <section className="dph-page-header">
      <div>
        {eyebrow ? <div className="dph-eyebrow">{eyebrow}</div> : null}
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
        {extra}
      </div>
      {actions ? <div className="dph-header-actions">{actions}</div> : null}
    </section>
  );
}
